<script>
    function broadcast(componentName, eventName, params) {
        this.$children.forEach(child => {
            var name = child.$options.componentName;

            if (name === componentName) {
                child.$emit.apply(child, [eventName].concat(params));
            } else {
                broadcast.apply(child, [componentName, eventName].concat([params]));
            }
        });
    }
    let emitter  = {
        methods: {
            dispatch(componentName, eventName, params) {
                var parent = this.$parent || this.$root;
                var name = parent.$options.componentName;

                while (parent && (!name || name !== componentName)) {
                    parent = parent.$parent;

                    if (parent) {
                        name = parent.$options.componentName;
                    }
                }
                if (parent) {
                    parent.$emit.apply(parent, [eventName].concat(params));
                }
            },
            broadcast(componentName, eventName, params) {
                broadcast.call(this, componentName, eventName, params);
            }
        }
    };

    export default {
        mixins: [emitter],
        props: {
            value: {
                type: Number,
                default: 0,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            fixed: {
                type: Number,
                default: 2
            },
            min: {
                type: Number,
                default: -999999999999
            },
            max: {
                type: Number,
                default: 999999999999
            },
        },
        data() {
            return {
                val: this.validate('' + this.value),
                f: false,
                old: 0,
            }
        },
        methods: {
            ms(v) {
                let mask = [];
                let a = this.validate(v).replace(/\d/g, '9').split('');
                a.forEach(i => {
                    if (i === '9') mask.push(/\d/);
                    if (i === '.') mask.push(/[\.,]/);
                    if (i === ' ') mask.push(' ');
                });
                return mask;
            },
            validate(v) {
                v = v.toString();
                if (v[0] === '-') {
                    v = v.replace(/\-/g, '');
                    v = '-' + v;
                } else {
                    v = v.replace(/\-/g, '');
                }
                let parts = v.toString().replace(/ /g, '').replace(/,/g, '.').replace(/^([^\.]*\.)|\./g, '$1').split(".");
                parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
                if (parts[1] && parts[1].length > this.fixed) parts[1] = parts[1].slice(0, this.fixed);
                return parts.join(".");

            },
            change(e) {
                this.$emit('change', this.currentValue);
                this.dispatch('ElFormItem', 'el.form.change', [this.currentValue]);
            },
            blur() {
                this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
            },
        },
        computed: {
            currentValue(){
                let val = 0;
                if (this.val !== '-') {
                    val = +(this.val.replace(/ /g, '').replace(/,/g, '.'));
                }
                return val;
            }
        },
        watch: {
            value(v) {
                this.val = this.validate('' + v);
            },
            val(v) {
                this.$emit('input', this.currentValue);
                this.dispatch('ElFormItem', 'el.form.change', [this.currentValue]);
            }
        },
        components: {},
        mounted() {

        },
        destroyed() {

        },
    }
</script>
<template>
    <div class="el-input el-input--mini">
        <masked-input
                type="text"
                @change="change"
                :value="val!=='0'?val:''"
                @input="val=$event"
                @blur="blur"
                :mask="ms"
                :guide="false"
                placeholderChar="#"
                class="el-input__inner"
                :disabled="disabled">
        </masked-input>
    </div>
</template>
<style lang="scss">
</style>
